import { QRCoupon } from "./qr-coupon";
export { QRCoupon };
